import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { IAnnotationService } from '../../../../../annotation.service';
import { IAnnotationsStore } from '../../../../../annotations.store';
import { IUndoRedoHistory } from '../../../../../undoRedoHistory.service';
import { SegmentationContextMenuItem } from '../../components/SegmentationContextMenuItem';

interface IProps {
  onMenuClose(): void;
  segmentationId: string;
}

export const DeleteSegmentationContextMenuItemContainer = observer((props: IProps): ReactElement => {
  const annotationService = useInjection(IAnnotationService.$);
  const undoRedoHistory = useInjection(IUndoRedoHistory.$);
  const annotationStore = useInjection(IAnnotationsStore.$);

  const handleAction = (): void => {
    const segmentationId = annotationStore.selectedSegmentation?.feature.id;
    if (segmentationId) {
      annotationService.deleteSegmentation(segmentationId);
      undoRedoHistory.addCommand(undoRedoHistory.getNewChangeStateCommand());
    }
  };

  return (
    <SegmentationContextMenuItem
      {...props}
      text='delete'
      icon='delete-option-icon'
      action={handleAction}
    />
  );
});
